import type { QueryKeyReturnType } from '@inflearn/codegen-wrapper';

import {
  API_ENDPOINT,
  getClientApiV1UserStatisticsQueryOptions,
  useClientApiV1UserStatisticsQuery,
} from '../../resources/@types/courseSchema';

interface UseClientV1UserStatisticsQuery {
  options?: Parameters<typeof useClientApiV1UserStatisticsQuery>[0]['options'];
}

export function useUserStatisticsQuery({ options }: UseClientV1UserStatisticsQuery) {
  return useClientApiV1UserStatisticsQuery({
    queryKey: getUserStatisticsQueryKey(),
    url: getUserStatisticsUrl(),
    options,
  });
}

export const getUserStatisticsQueryKey = (): QueryKeyReturnType => [
  API_ENDPOINT.CLIENT_V1_USER_STATISTICS,
];

export const getUserStatisticsUrl = (): string => API_ENDPOINT.CLIENT_V1_USER_STATISTICS;

export function getUserStatisticsQueryOptions() {
  return getClientApiV1UserStatisticsQueryOptions({
    queryKey: getUserStatisticsQueryKey(),
    url: getUserStatisticsUrl(),
  });
}

export default useUserStatisticsQuery;
